// @ts-nocheck
import React from 'react';
import { reactLazyRetry } from '../../utils/Utils';
import { DEFAULT_ROUTE_CONFIG } from '../../const/defaultRoutesConfig';

const Dashboard = reactLazyRetry(() => import('./pages/Dashboard'));

/**
 * Home route definitions and metadata used by the application router
 * and permission-aware navigation (QuickLinks).
 */
export const homeRoutes = [
  {
    name: 'Home',
    key: 'home',
    path: DEFAULT_ROUTE_CONFIG?.home?.path || 'home',
    element: <Dashboard />,
    permission: 'Home',
    quickLink: {
      enabled: false,
    },
  },
];
